import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import VerticalLabelList from '../../../../label/VerticalLabelList';
import FieldSet from '../../../../fieldset/FieldSet';
import NcDlService from '../../../../../service/NcDlService';
import { buildSuccessStatus, buildFailureStatus, } from '../../../../constants/AlertConstants';
import AsyncActionButton from '../../../../button/AsyncActionButton';
import { tabKeys, } from '../../../../../modules/Constants';

export default class NcDlDetailedOrder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: {},
    };
  }

  componentDidMount() {
    const self = this;
    const { selectedOrder, } = this.props;
    // only available when using service calls
    if (selectedOrder.fullOrderWithPayment) {
      self.setState({ order: selectedOrder.fullOrderWithPayment, });
    }
  }

  onDismiss() {
    this.setState({
      status: null,
    });
  }

  formatDate(dateString) {
    if (dateString === undefined || dateString === null) return '';
    return moment.unix(dateString / 1000).format('LL');
  }

  formatDateTime(dateString) {
    if (dateString === undefined || dateString === null) return '';
    return moment.unix(dateString / 1000).format('LLLL');
  }

  resendTdcRequest(transactionId, lineItemId) {
    this.setState({
      isLoading: true,
    });

    NcDlService.resendTdc(transactionId, lineItemId)
      .then(() => {
        this.setState({
          status: buildSuccessStatus(
            `A temporary driving certificate (TDC) has been successfully added to the queue for line item id ${lineItemId} found in
            transaction id ${transactionId}.  Please NOTE that it could take some time for full completion.`,
            () => this.onDismiss()
          ),
        });
      })
      .catch(() => {
        this.setState({
          status: buildFailureStatus(
            `Unable to add a temporary driving certificate (TDC) to the queue for line item id ${lineItemId} found in transaction id
              ${transactionId}`,
            () => this.onDismiss()
          ),
        });
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  }

  render() {
    const { order, isLoading, status, } = this.state;
    const options = {};
    options.headerFormatter = object => _.startCase(object.header);

    const resendTdcComponent = (
      <AsyncActionButton
        type="button"
        isLoading={isLoading}
        contents={tabKeys.RESEND_TDC_KEY}
        onClick={() => this.resendTdcRequest(order.transactionId, order.lineItemId)}
      />
    );

    const orderItems = order.dlPayableType === 'RENEWAL'
      ? VerticalLabelList.toList({
        'Drivers License Number': order.driversLicenseNumber,
        'First Name': order.firstName,
        'Last Name': order.lastName,
        'Middle Name': order.middleName,
        Suffix: order.suffixName,
        'Date of Birth': `${order.birthDate}`,
        'SSN Last Four': order.ssnLastFour,
        'Expiration Date': `${order.expirationDate}`,
        Endorsements: order.endorsements,
        'Hearing Impairment Status': order.hearingImpairmentStatus,
        Deployed: order.isDeployed,
        Military: order.isMilitary,
        'Organ Donor': order.organDonor,
        'License Class': order.licenseClass,
        'Out of State License': order.outOfStateLicense,
        'Out of State License Message': order.outOfStateLicenseMessage,
        'Photo on File': order.photoOnFile,
        'Real Id': order.realId,
        'Registered Voter': order.registeredVoter,
        'Registration Fee': order.registrationFee_value,
        'Renewal Term': order.renewalTerm,
        Restrictions: order.restrictions,
      }) : VerticalLabelList.toList({
        'Drivers License Number': order.driversLicenseNumber,
        'First Name': order.firstName,
        'Last Name': order.lastName,
        'Middle Name': order.middleName,
        'Date of Birth': `${order.birthDate}`,
        'SSN Last Four': order.ssnLastFour,
        'Alien No.': order.alienNumber,
        'I-94 No.': order.i94Number,
        'Expiration Date': `${order.expirationDate}`,
        Endorsements: order.endorsements,
        Restrictions: order.restrictions,
        'Reason for Duplicate': order.reason,
        'Hearing Impaired': order.isHearingImpaired,
        Eligible: order.isEligible,
        CDL: order.isCdl,
        'Registered Voter': order.isRegisteredVoter,
        'Out of State License Cancel': order.oosLicenseCancelInd,
        'Out of State License Cancel Messge': order.oosLicenseCancelMessage,
        'Issuance Group': order.issuanceGroup,
        'Issuance Type': order.issuanceType,
        'Issuance Type Code': order.issuanceTypeCode,
        'Issuance Class Code': order.issuanceClassCode,
        'Organ Donor': order.isOrganDonor,

      });

    // const rawOrder = VerticalLabelList.toList(order);

    const orderPaymentItems = VerticalLabelList.toList({
      Id: order.id,
      CustomerId: order.customerId,
      ServiceOfferingId: order.serviceOfferingId,
      'Drivers License Number': order.driversLicenseNumber,
      'Free Order': order.freeOrder,
      'Payment Account Type': order.paymentAccountType,
      'Payment Timestamp': `${order.paymentTimeStamp}`,
      'Transaction Id': order.transactionId,
      'LineItem Id': order.lineItemId,
      'ID Card': order.isIdCard,
      'Order Type': order.dlPayableType,
      'Line Item Amount': order.lineItemAmount_value,
      'Currency Code': order.lineItemAmount_currencyCode,
      'Refund Ids': order.refundIds,
      DriversLicensePayableId: order.driversLicensePayableId,
      'Processed By Integration': order.processedByIntegration,
      'Processed By Integration Timestamp': `${order.processedByIntegrationTimeStamp}`,
      'PDF Sent': order.pdfSent,
      'PDF Request Sent Timestamp': `${order.sentPdfRequestTimestamp}`,
      Validated: order.validated,
      'Failed Validation': order.failedValidation,
    });

    const address = (
      addressType,
      street1,
      street2,
      city,
      county,
      state,
      stateCode,
      zip,
      country
    ) => VerticalLabelList.toList({
      'Address Type': addressType,
      'Street 1': street1,
      'Street 2': street2,
      City: city,
      County: county,
      State: state,
      StateCode: stateCode,
      Zip: zip,
      Country: country,
    });

    return (
      <div>
        <div className="column-2" style={{ marginTop: '50px', }}>
          <FieldSet title="Actions">
            {resendTdcComponent}
            {status}
          </FieldSet>
        </div>
        <div className="column-2" style={{ marginTop: '50px', }}>
          <FieldSet title="Summary">
            <VerticalLabelList
              items={orderItems}
            />
          </FieldSet>
        </div>

        <div className="column-2" style={{ marginTop: '50px', }}>
          <FieldSet title="Transaction">
            <VerticalLabelList
              items={orderPaymentItems}
            />
          </FieldSet>
        </div>

        <div style={{ marginTop: '20px', }}>
          <FieldSet title="Residential Address">
            <VerticalLabelList
              items={address(
                order.residentAddress_addressType,
                order.residentAddress_street1,
                order.residentAddress_street2,
                order.residentAddress_city,
                order.residentAddress_county,
                order.residentAddress_state,
                order.residentAddress_stateCode,
                order.residentAddress_zip,
                order.residentAddress_country
              )}
            />
          </FieldSet>
        </div>

        <div style={{ marginTop: '20px', }}>
          <FieldSet title="Mailing Address">
            <VerticalLabelList
              items={address(
                order.mailingAddress_addressType,
                order.mailingAddress_street1,
                order.mailingAddress_street2,
                order.mailingAddress_city,
                order.mailingAddress_county,
                order.mailingAddress_state,
                order.mailingAddress_stateCode,
                order.mailingAddress_zip,
                order.mailingAddress_country
              )}
            />
          </FieldSet>
        </div>
      </div>
    );
  }
}

NcDlDetailedOrder.propTypes = {
  selectedOrder: PropTypes.instanceOf(Object).isRequired,
};
